export const factTableConstants = {
     FACT_TABLE_LIST_REQUEST: "FACT_TABLE_LIST_REQUEST",
     FACT_TABLE_LIST_COMPLETE: "FACT_TABLE_LIST_COMPLETE",

     FACT_TABLE_SEARCH_REQUEST: "FACT_TABLE_SEARCH_REQUEST",
     FACT_TABLE_SEARCH_COMPLETE: "FACT_TABLE_SEARCH_COMPLETE",

     FACT_TABLE_ADD_REQUEST: "FACT_TABLE_ADD_REQUEST",
     FACT_TABLE_ADD_COMPLETE: "FACT_TABLE_ADD_COMPLETE",

     FACT_TABLE_UPDATE_REQUEST: "FACT_TABLE_UPDATE_REQUEST",
     FACT_TABLE_UPDATE_COMPLETE: "FACT_TABLE_UPDATE_COMPLETE",

     FACT_TABLE_DELETE_REQUEST: "FACT_TABLE_DELETE_REQUEST",
     FACT_TABLE_DELETE_COMPLETE: "FACT_TABLE_DELETE_COMPLETE",

     FACT_TABLE_GET_REQUEST: "FACT_TABLE_GET_REQUEST",
     FACT_TABLE_GET_COMPLETE: "FACT_TABLE_GET_COMPLETE",

     FACT_TABLE_TYPES_REQUEST: "FACT_TABLE_TYPES_REQUEST",
     FACT_TABLE_TYPES_COMPLETE: "FACT_TABLE_TYPES_COMPLETE",

     FACT_TABLE_LABELS_REQUEST: "FACT_TABLE_LABELS_REQUEST",
     FACT_TABLE_LABELS_COMPLETE: "FACT_TABLE_LABELS_COMPLETE",

     FACT_TABLE_ACTIVE_INACTIVE_REQUEST: "FACT_TABLE_ACTIVE_INACTIVE_REQUEST",
     FACT_TABLE_ACTIVE_INACTIVE_COMPLETE: "FACT_TABLE_ACTIVE_INACTIVE_COMPLETE",

     FACT_TABLE_SCHEMA_VALUE_LIST_REQUEST:
          "FACT_TABLE_SCHEMA_VALUE_LIST_REQUEST",
     FACT_TABLE_SCHEMA_VALUE_LIST_COMPLETE:
          "FACT_TABLE_SCHEMA_VALUE_LIST_COMPLETE",

     FACT_TABLE_VALUE_ADD_REQUEST: "FACT_TABLE_VALUE_ADD_REQUEST",
     FACT_TABLE_VALUE_ADD_COMPLETE: "FACT_TABLE_VALUE_ADD_COMPLETE",

     FACT_TABLE_VALUE_UPDATE_REQUEST: "FACT_TABLE_VALUE_UPDATE_REQUEST",
     FACT_TABLE_VALUE_UPDATE_COMPLETE: "FACT_TABLE_VALUE_UPDATE_COMPLETE",

     FACT_TABLE_SCHEMA_VALUE_DELETE_REQUEST:
          "FACT_TABLE_SCHEMA_VALUE_DELETE_REQUEST",
     FACT_TABLE_SCHEMA_VALUE_DELETE_COMPLETE:
          "FACT_TABLE_SCHEMA_VALUE_DELETE_COMPLETE",

     FACT_TABLE_SCHEMA_VALUE_GET_REQUEST: "FACT_TABLE_SCHEMA_VALUE_GET_REQUEST",
     FACT_TABLE_SCHEMA_VALUE_GET_COMPLETE:
          "FACT_TABLE_SCHEMA_VALUE_GET_COMPLETE",

     FACT_TABLE_GET_ALL_SCHEMA_TYPE_REQUEST:
          " FACT_TABLE_GET_ALL_SCHEMA_TYPE_REQUEST",
     FACT_TABLE_GET_ALL_SCHEMA_TYPE_COMPLETE:
          " FACT_TABLE_GET_ALL_SCHEMA_TYPE_COMPLETE",

     FACT_TABLE_GET_ALL_SCHEMA_ATTRIBUTE_REQUEST:
          "FACT_TABLE_GET_ALL_SCHEMA_ATTRIBUTE_REQUEST",
     FACT_TABLE_GET_ALL_SCHEMA_ATTRIBUTE_COMPLETE:
          "FACT_TABLE_GET_ALL_SCHEMA_ATTRIBUTE_COMPLETE",

     FACT_TABLE_SCHEMA_VALUE_REORDER_REQUEST:
          "FACT_TABLE_SCHEMA_VALUE_REORDER_REQUEST",
     FACT_TABLE_SCHEMA_VALUE_REORDER_COMPLETE:
          "FACT_TABLE_SCHEMA_VALUE_REORDER_COMPLETE",

     FACT_TABLE_GET_VALUE_REQUEST: "FACT_TABLE_GET_VALUE_REQUEST",
     FACT_TABLE_GET_VALUE_COMPLETE: "FACT_TABLE_GET_VALUE_COMPLETE",

     FACT_TABLE_SCHEMA_TEMPLATE_REQUEST: "FACT_TABLE_SCHEMA_TEMPLATE_REQUEST",
     FACT_TABLE_SCHEMA_TEMPLATE_COMPLETE: "FACT_TABLE_SCHEMA_TEMPLATE_COMPLETE",

     CSV_FILE_TYPE: "text/csv",

     FACT_TABLE_CREATE_BY_CSV_REQUEST: "FACT_TABLE_CREATE_BY_CSV_REQUEST",
     FACT_TABLE_CREATE_BY_CSV_COMPLETE: "FACT_TABLE_CREATE_BY_CSV_COMPLETE",

     GET_FACT_TABLE_JSON_SCHEMA_REQUEST: "GET_FACT_TABLE_JSON_SCHEMA_REQUEST",
     GET_FACT_TABLE_JSON_SCHEMA_COMPLETE: "GET_FACT_TABLE_JSON_SCHEMA_COMPLETE",

     ADD_FACT_TABLE_SCHEMA_RECORD_REQUEST:
          "ADD_FACT_TABLE_SCHEMA_RECORD_REQUEST",
     ADD_FACT_TABLE_SCHEMA_RECORD_COMPLETE:
          "ADD_FACT_TABLE_SCHEMA_RECORD_COMPLETE",

     DELETE_FACT_TABLE_SCHEMA_RECORD_REQUEST:
          "DELETE_FACT_TABLE_SCHEMA_RECORD_REQUEST",
     DELETE_FACT_TABLE_SCHEMA_RECORD_COMPLETE:
          "DELETE_FACT_TABLE_SCHEMA_RECORD_COMPLETE",

     EDIT_FACT_TABLE_SCHEMA_RECORD_REQUEST:
          "EDIT_FACT_TABLE_SCHEMA_RECORD_REQUEST",
     EDIT_FACT_TABLE_SCHEMA_RECORD_COMPLETE:
          "EDIT_FACT_TABLE_SCHEMA_RECORD_COMPLETE",

     GET_FACT_TABLE_SCHEMA_RECORD_REQUEST:
          "GET_FACT_TABLE_SCHEMA_RECORD_REQUEST",
     GET_FACT_TABLE_SCHEMA_RECORD_COMPLETE:
          "GET_FACT_TABLE_SCHEMA_RECORD_COMPLETE",
};
